import { ProductTypeEnum } from 'src/app/product-capture/model/enums/product-capture.enums';
import {
  PAYOFF_PARTICIPATION,
  SUMMARY_REFERENCE_ENTITIES,
  PAYOFF_COUPON_FLOATING_PERIODS,
  PAYOFF_COUPON_OBVS_FREQUENCY,
  PAYOFF_COUPON_MEMORY,
  PAYOFF_COUPON_CONVERSION,
  PAYOFF_PARTICIPATION_BASE_TYPE,
  PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
  PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
  PAYOFF_PARTICIPATION_UPSIDE_TYPE,
  SUMMARY_UNDERLYING_ASSETS,
  PAYOFF_CALLABILITY_CALLABILITY,
  PAYOFF_COUPON_TYPE,
  PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
  SUMMARY_FREQUENCY,
  SUMMARY_PERFORMANCE_TYPE,
} from '../../mockups/consts/product-capture-field-selectors.consts';
import { COUPON_TYPE } from 'src/app/product-capture/model/enums/coupon-type.enum';
import { PERFORMANCE_TYPE_KEYS } from 'src/app/product-capture/model/consts/performance-type.const';

export const FX_DIGITAL_COUPON_NOTE_SETTINGS = {
  id: ProductTypeEnum.FX_DIGITAL_COUPON_NOTE,
  label: 'FX Digital Coupon Note',
  effects: [
    {
      formControlNames: [
        PAYOFF_PARTICIPATION,
        SUMMARY_REFERENCE_ENTITIES,
        PAYOFF_CALLABILITY_CALLABILITY,
        PAYOFF_COUPON_FLOATING_PERIODS,
        PAYOFF_COUPON_OBVS_FREQUENCY,
        PAYOFF_COUPON_MEMORY,
        PAYOFF_COUPON_CONVERSION,
      ],
      hidden: true,
    },
    {
      formControlNames: [
        PAYOFF_CALLABILITY_CALL_EVENT_TYPE,
        PAYOFF_PARTICIPATION_UPSIDE_TYPE,
        PAYOFF_PARTICIPATION_BASE_TYPE,
        PAYOFF_PARTICIPATION_DOWNSIDE_TYPE,
        PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE,
      ],
      selectValues: ['NONE'],
      hidden: true,
    },
    {
      formControlNames: [SUMMARY_UNDERLYING_ASSETS],
      hidden: false,
    },
    {
      formControlNames: [PAYOFF_COUPON_TYPE],
      selectValues: [COUPON_TYPE.FIXED_AND_CONDITIONAL],
      readOnly: true,
      hidden: false,
    },
    {
      formControlNames: [SUMMARY_FREQUENCY],
      selectValues: ['AT_MATURITY'],
      readOnly: true,
      hidden: false,
    },
    {
      formControlNames: [SUMMARY_PERFORMANCE_TYPE],
      selectValues: [PERFORMANCE_TYPE_KEYS.SINGLE],
      readOnly: true,
    },
  ],
};
